import { render, staticRenderFns } from "./TabOrder.vue?vue&type=template&id=0ed9d451"
import script from "./TabOrder.vue?vue&type=script&lang=js"
export * from "./TabOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports